import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/api";
import Logo from "@/components/Logo";

function formatErr(detail) {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.post("/auth/login", form);
      localStorage.setItem("iksha_admin_token", res.data.token);
      toast.success("Welcome back, studio.");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const inputCls = "w-full bg-transparent border-b border-paper/25 focus:border-brand outline-none py-3 text-paper placeholder:text-paper/30 transition-colors";

  return (
    <main data-testid="admin-login-page" className="min-h-screen bg-ink text-paper flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <Logo dark />
        <h1 className="font-display text-4xl tracking-tight mt-10">Studio admin</h1>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-paper/40 mt-2">Restricted — IKSHA team only</p>
        <form onSubmit={submit} data-testid="admin-login-form" className="mt-10 space-y-6">
          <input required type="email" data-testid="admin-email-input" value={form.email}
            onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} placeholder="Email" className={inputCls} />
          <input required type="password" data-testid="admin-password-input" value={form.password}
            onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))} placeholder="Password" className={inputCls} />
          <button type="submit" disabled={busy} data-testid="admin-login-btn"
            className="w-full bg-brand text-paper py-4 font-mono text-xs uppercase tracking-[0.2em] hover:bg-brand-hover transition-colors disabled:opacity-50">
            {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <a href="/" data-testid="admin-back-home" className="block mt-8 font-mono text-[10px] uppercase tracking-[0.25em] text-paper/40 hover:text-brand transition-colors">
          ← Back to site
        </a>
      </div>
    </main>
  );
}
